import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { CookieService } from 'ngx-cookie';
var Http2 = /** @class */ (function () {
    function Http2(httpClient, cookies, rootUrl, pdauthAppName, isApi) {
        if (pdauthAppName === void 0) { pdauthAppName = 'MapCore'; }
        if (isApi === void 0) { isApi = false; }
        this.httpClient = httpClient;
        this.cookies = cookies;
        this.rootUrl = rootUrl;
        this.pdauthAppName = pdauthAppName;
        this.isApi = isApi;
        this.tQuery = 'query';
        this.tMutation = 'mutation';
        this.MaxQueryAndVariablesLength = 1000;
        if (rootUrl && rootUrl.lastIndexOf('/') !== rootUrl.length - 1) {
            rootUrl = rootUrl + '/';
        }
        this.rootUrl = rootUrl;
    }
    Object.defineProperty(Http2.prototype, "url", {
        get: function () {
            return this.rootUrl;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Perform any request type
     */
    Http2.prototype.request = function (url, config) {
        if (config.file) {
            var formData = new FormData();
            formData.append('file', config.file, config.file.name);
            config = {
                method: 'POST',
                body: formData,
                headers: {}
            };
        }
        else {
            var isFormData = config.body && config.body instanceof FormData;
            if (config.body && !isFormData) {
                config.body = JSON.stringify(config.body);
            }
            config = tslib_1.__assign({ headers: !isFormData ? {
                    'Content-Type': 'application/json'
                } : {}, params: {} }, config);
        }
        url = this.rootUrl ? this.rootUrl + url : url;
        // remove any trailing slash from the url
        if (url.lastIndexOf('/') === url.length - 1) {
            url = url.substring(0, url.length - 1);
        }
        if (this.isApi && !url.startsWith(window.location.origin)) {
            var token = this.cookies.get('PDAuth_token');
            if (token) {
                config.headers['X-Auth-Token'] = token;
            }
            config.withCredentials = true;
        }
        if (config.params && config.params.variables) {
            config.params.variables = config.params.variables.replaceAll('+', '%2B'); // Urlencode plus sign otherwise the plus sign is replaced with a space.
        }
        return this.httpClient.request(config.method, url, config).toPromise().then(function (result) {
            return result;
        }, function (errorResponse) {
            return Promise.reject(errorResponse.error);
        });
    };
    /**
     * Perform a GET graphql query
     * @param query GraphQL query
     * @param variables variables to be inserted into query
     * @param method "GET" | "POST" | "PUT" | "DELETE"
     * @param dataPath retrieves the data at the specified named path.
     */
    Http2.prototype.graphqlRequest = function (query, variables, method, dataPath) {
        if (method === void 0) { method = 'GET'; }
        if (dataPath === void 0) { dataPath = null; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, queryName, pdauthAppName, type, response, e_2, parts, result, parts_1, parts_1_1, part;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        pdauthAppName = this.pdauthAppName;
                        type = query.trim().toLowerCase().startsWith(this.tQuery) ? this.tQuery : this.tMutation;
                        if (method === 'GET' && (query.length + JSON.stringify(variables).length) > this.MaxQueryAndVariablesLength) {
                            method = 'POST';
                        }
                        if (type === this.tQuery) {
                            // find the query name from the query and use that in the querystring to help with debugging to distinguish this request
                            queryName = query.substring(query.indexOf(this.tQuery) + this.tQuery.length, query.indexOf('{')).trim();
                        }
                        else {
                            queryName = query.substring(query.indexOf(this.tMutation) + this.tMutation.length, query.indexOf('(')).trim();
                        }
                        // remove any excess whitespace from the query only for GET requests since this is passed on the URL
                        if (method === 'GET') {
                            query = this.graphqlTrim(query);
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.request("graphql?" + queryName + "&pdauthAppName=" + pdauthAppName, {
                                body: method !== 'GET' ? {
                                    query: query,
                                    variables: variables
                                } : undefined,
                                method: method,
                                params: method === 'GET' ? {
                                    query: query,
                                    variables: JSON.stringify(variables)
                                } : undefined
                            })];
                    case 2:
                        response = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _b.sent();
                        if (e_2 && !e_2.message && e_2.errors && e_2.errors[0]) {
                            e_2.message = e_2.errors[0].message;
                        }
                        throw e_2;
                    case 4:
                        if (!dataPath) {
                            return [2 /*return*/, response.data];
                        }
                        else {
                            parts = dataPath.split('.');
                            result = response.data;
                            try {
                                for (parts_1 = tslib_1.__values(parts), parts_1_1 = parts_1.next(); !parts_1_1.done; parts_1_1 = parts_1.next()) {
                                    part = parts_1_1.value;
                                    result = result[part];
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (parts_1_1 && !parts_1_1.done && (_a = parts_1.return)) _a.call(parts_1);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                            return [2 /*return*/, result];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Http2.prototype.graphqlTrim = function (text) {
        text = text.replace(/\s+/g, ' ');
        return text;
    };
    Http2.prototype.get = function (url, params, config) {
        var cfg = tslib_1.__assign({}, config, { method: 'GET', params: params });
        return this.request(url, cfg);
    };
    Http2.prototype.post = function (url, body, config) {
        var cfg = tslib_1.__assign({ body: body, method: 'POST' }, config);
        return this.request(url, cfg);
    };
    Http2.prototype.put = function (url, body, config) {
        var cfg = tslib_1.__assign({ body: body, method: 'PUT' }, config);
        return this.request(url, cfg);
    };
    Http2.prototype.delete = function (url, body, config) {
        var cfg = tslib_1.__assign({ body: body, method: 'DELETE' }, config);
        return this.request(url, cfg);
    };
    return Http2;
}());
export { Http2 };
var Http2Factory = /** @class */ (function () {
    function Http2Factory(httpClient, cookies) {
        this.httpClient = httpClient;
        this.cookies = cookies;
    }
    Http2Factory.prototype.create = function (url, pdauthAppName, isApi) {
        if (pdauthAppName === void 0) { pdauthAppName = 'MapCore'; }
        if (isApi === void 0) { isApi = false; }
        return new Http2(this.httpClient, this.cookies, url, pdauthAppName, isApi);
    };
    return Http2Factory;
}());
export { Http2Factory };
